module.exports = __webpack_public_path__ + "img/about-img-1.7ae7a459.png";